import React from 'react';
import PropTypes from "prop-types"; 
import {TIMER_INTERVAL, SUCCESS, WARNING, DANGER,SHOW_MESSAGE_TO_UI} from 'utils/constants';
import {translate} from 'utils/common';
class MessagePanel extends React.Component{
    constructor(props){
        super(props);
        this.state = {intervalId:0, message:'', type:''} ;
        this.timer = this.timer.bind(this);
        this.updateUIMessage = this.updateUIMessage.bind(this);
        
        let ev = {};
        ev[SHOW_MESSAGE_TO_UI] = this.updateUIMessage;
        app.events.subscribe(ev);      
    }
    updateUIMessage(params){
        params = params && params.constructor == Array?params[0]:params;
        clearTimeout(this.state.intervalId);
        const message = params.message? React.isValidElement(message)? params.message : translate(params.message) : '';

        this.setState({message, type: params ? params["msgType"]:'' || '' }, function(){
            if(this.state.message) {
                var intervalId = setTimeout(this.timer, TIMER_INTERVAL);
                // store intervalId in the state so it can be accessed later:
                this.setState({intervalId});
            }
        });        
    } 
    componentWillUnmount() {
        // use intervalId from the state to clear the interval
        clearTimeout(this.state.intervalId);
    }
    timer() { 
        this.setState({message:'', type:''});        
    }

    render(){
        const MSG_TYPE={'success': SUCCESS, 'error': DANGER, 'warning': WARNING}
        const Message = this.state.message;
        return( <React.Fragment>
            {this.state.message &&  
                <div className={"alert alert-"+MSG_TYPE[this.state.type]}><div className="arrow"></div>
                {
                    (typeof Message === 'object' || typeof Message === 'function') && 
                    <Message/>
                }
                {
                    typeof Message === 'string' && 
                    this.state.message
                }
                    <a onClick={this.updateUIMessage} className="messagepanel-close">&times;</a> 
                </div>
             }
            </React.Fragment>
        )
    }
}

MessagePanel.defaultProps = {
    type: 'warning'
}
MessagePanel.propTypes = {
    // type:PropTypes.string.isRequired,
    // type:PropTypes.oneOf(['success', 'error', 'warning']),
    // message: PropTypes.string.isRequired,
}
export default MessagePanel;